import { NestedMenuComponent } from "../components/common/nestedmenu/nested.menu";


export const MW_COMPONENTS = [
    NestedMenuComponent
];